import React from 'react';
import _ from 'lodash';
import CustomSlider from './components/SettingsSlider';
import CustomTextArea from './components/SettingsTextArea';
import CustomInput from './components/SettingsInput';
import SettingsJsonOptionsRadio from './components/SettingsJsonOptionsRadio';
import SettingsJsonOptionsMixed from './components/SettingsJsonOptionsMixed';
import {
  validateHasChangedWithValue,
  validateHasChangedWithoutValue
} from './SettingsUtils';

const RADIO_BUTTON = 'radio_button';
const RADIO_BUTTON_NO_VALUE = 'radio_button_no_value';

const schemaComponents = [
  {
    isSchemaMatchFn: schema =>
      schema.isInt && schema.isInt.min && schema.isInt.max,
    isCustomMatchFn: customOptions => true,
    componentCreator: (setting, settingDimension) => (
      <CustomSlider
        key={setting.name}
        {...setting}
        {...settingDimension}
        useEffectValidationFN={validateHasChangedWithValue}
      />
    )
  },
  {
    isSchemaMatchFn: schema => schema.isArray,
    isCustomMatchFn: customOptions => true,
    componentCreator: (setting, settingDimension) => (
      <CustomTextArea
        key={setting.name}
        dataCy={setting.label}
        {...setting}
        {...settingDimension}
        useEffectValidationFN={validateHasChangedWithValue}
      />
    )
  },
  {
    isSchemaMatchFn: schema => schema.isString,
    isCustomMatchFn: customOptions => true,
    componentCreator: (setting, settingDimension) => (
      <CustomInput
        key={setting.name}
        {...setting}
        {...settingDimension}
        useEffectValidationFN={validateHasChangedWithValue}
      />
    )
  },
  {
    isSchemaMatchFn: schema => schema.isJSON,
    isCustomMatchFn: customOptions =>
      _.get(customOptions, 'format', '') === RADIO_BUTTON,
    componentCreator: (setting, settingDimension) => (
      <SettingsJsonOptionsRadio
        key={setting.name}
        {...setting}
        {...settingDimension}
        useEffectValidationFN={validateHasChangedWithValue}
      />
    )
  },
  {
    isSchemaMatchFn: schema => schema.isJSON,
    isCustomMatchFn: customOptions =>
      _.get(customOptions, 'format', '') === RADIO_BUTTON_NO_VALUE,
    componentCreator: (setting, settingDimension) => (
      <SettingsJsonOptionsRadio
        key={setting.name}
        {...setting}
        {...settingDimension}
        useEffectValidationFN={validateHasChangedWithoutValue}
      />
    )
  },
  {
    isSchemaMatchFn: schema => schema.isJSON,
    isCustomMatchFn: customOptions =>
      _.get(customOptions, 'format', '') === 'mixed',
    componentCreator: (setting, settingDimension) => (
      <SettingsJsonOptionsMixed
        key={setting.name}
        {...setting}
        {...settingDimension}
        useEffectValidationFN={validateHasChangedWithValue}
        dataCy={setting.name}
      />
    )
  }
];

export function getSettingInputComponent(setting, settingDimension) {
  const componentCreator = _.get(
    schemaComponents.find(
      ({ isSchemaMatchFn, isCustomMatchFn }) =>
        isSchemaMatchFn(setting.schema.validationSchema) &&
        isCustomMatchFn(_.get(setting, 'customOptions', {}))
    ),
    'componentCreator',
    null
  );

  if (!componentCreator) {
    return <div key={setting.definitionId} />;
  }

  return componentCreator(setting, settingDimension);
}
